import Vue from 'vue';

export default {
  methods: {
    getServerTimeFormatWithoutTime() {
      return 'YYYY-MM-DD'
    }
  }
};
